import styled from '@emotion/styled';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import * as colors from 'src/assets/colors';

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    position: relative;
    display: flex;
    align-items: center;
    flex: 1;
    max-width: 150px;
`;

export const StyledInput = styled('input', { label: 'StyledInput' })<{ hasError: boolean; isModified: boolean }>`
    border-width: 1px;
    border-style: solid;
    border-color: ${(props): string => {
        if (props.hasError) return colors.inputField.borderColorError;
        if (props.isModified) return colors.inputField.borderColorModified;
        return colors.inputField.borderColor;
    }};
    background-color: ${(props): string => {
        if (props.hasError) return colors.inputField.bgColorError;
        return colors.inputField.bgColor;
    }};
    color: ${colors.inputField.txtColor};
    font-size: ${fontSize.regular};
    font-weight: ${fontWeight.medium};
    height: 36px;
    line-height: 1.4;
    outline: none;
    width: 100%;
    padding: 8px ${(props): string => (props.hasError ? '32px' : '12px')} 8px 12px;
    border-radius: 4px;
    text-align: left;

    &:focus {
        border-color: ${(props): string => (props.hasError ? colors.inputField.borderColorError : colors.inputField.borderColorFocus)};
    }

    &:disabled {
        background-color: ${colors.inputField.bgColorDisabled};
        border-color: ${colors.inputField.borderColor};
        cursor: not-allowed;
    }
`;

export const ErrorIcon = styled('div', { label: 'ErrorIcon' })`
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: help;
`;

export const ErrorTooltip = styled('div', { label: 'ErrorTooltip' })<{ show: boolean }>`
    position: absolute;
    right: 0;
    bottom: calc(100% + 8px);
    transform: translateX(0);
    background-color: ${colors.inputField.tooltip.bgColor};
    color: ${colors.inputField.tooltip.txtColor};
    padding: 6px 10px;
    border-radius: 4px;
    font-size: ${fontSize.small};
    white-space: nowrap;
    z-index: 1000;
    opacity: ${(props): number => (props.show ? 1 : 0)};
    visibility: ${(props): string => (props.show ? 'visible' : 'hidden')};
    transition: opacity 0.2s, visibility 0.2s;
    pointer-events: none;

    &::before {
        content: '';
        position: absolute;
        right: 8px;
        bottom: -4px;
        transform: rotate(45deg);
        width: 8px;
        height: 8px;
        background-color: ${colors.inputField.tooltip.bgColor};
    }
`;
